import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BrokerService } from "./broker.service";
import { capitalizeFirstLetter } from "./utility.service";

export interface Breadcrumb {
  name?: string;
  routeLink?: any[];
  active?: boolean;
}

@Injectable()
export class BreadcrumbService {
  public breadcrumbs: Breadcrumb[] = [];
  public last: Breadcrumb;

  constructor(private broker: BrokerService) {
    this.broker
      .on<ActivatedRoute>("navigation.ended")
      .subscribe((route) => this.updateBreadcrumbs(route));
  }

  public updateBreadcrumbs(route: ActivatedRoute) {
    let breadcrumbs = BreadcrumbService.parse(route);

    this.last = breadcrumbs.pop();
    this.breadcrumbs = breadcrumbs;
  }

  public static parse(route: ActivatedRoute): Breadcrumb[] {
    let breadcrumbs: Breadcrumb[] = [];

    let currentRoute = route.root,
      urlParts: any[] = [];
    // console.log(currentRoute.snapshot);

    do {
      let childrenRoutes = currentRoute.children,
        snapshot = currentRoute.snapshot,
        next = childrenRoutes.filter((x) => x.outlet === "primary");

      snapshot.url.forEach((segment) => {
        // console.log(segment.path);
        urlParts.push(segment.path);
        urlParts.push(segment.parameters);

        breadcrumbs.push({
          name: capitalizeFirstLetter(decodeURIComponent(segment.path)),
          routeLink: urlParts.slice(0),
        });
      });
      currentRoute = next && next[0];
    } while (currentRoute);

    return breadcrumbs;
  }

  routerLinkFromLast(params: any[]) {
    return this.last.routeLink.concat(params);
  }

  routerLinkFromLastReplacingParams(params: any) {
    let lastCopy = this.last.routeLink.slice(0);
    lastCopy.pop();
    lastCopy.push(params);
    return lastCopy;
  }

  routeParams() {
    let lastRouterLink = this.last.routeLink;
    return lastRouterLink[lastRouterLink.length - 1];
  }
}
